import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import PartnerPortalWrapper from "./Components/PartnerPortal/partnerPortalWrapper";
import ProtectedRoute from "./protectedRoute";
import LoginPageWrapper from "./Components/Login/loginPageWrapper";
import "./Stylesheets/fonts.css";
import "./Stylesheets/style.css";
import "./Stylesheets/common.css";
import SignUpPageWrapper from "./Components/SignUp/signUpPageWrapper";
import PaypalLoginReturnWrapper from './Components/Paypal/paypalLoginReturnWrapper';
import PartnerWelcomeWrapper from './Components/Welcome/partnerWelcomeWrapper';

function App() {
    return (
        <>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/login" component={LoginPageWrapper}/>
                    <ProtectedRoute exact path="/partner-portal/welcome" component={PartnerWelcomeWrapper}/>
                    <ProtectedRoute exact path="/partner-portal/paypal" component={PaypalLoginReturnWrapper}/>
                    <ProtectedRoute exact path="/partner-portal" component={PartnerPortalWrapper}/>
                    <Route exact path="/signup" component={() => <SignUpPageWrapper />}></Route>
                    <Route path="*">
                        <Redirect to="/login"/>
                    </Route>
                </Switch>
            </BrowserRouter>
        </>
    );
}

export default App;
